// extracted by mini-css-extract-plugin
export var attachment = "_np-a";
export var emailContainer = "_np-4";
export var emailContentPaddedContainer = "_np-b";
export var emailHeader = "_np-6";
export var emailIframe = "_np-3";
export var emailInfoIcon = "_np-9";
export var emailShortenedSummary = "_np-e";
export var infoDropdown = "_np-0";
export var infoRowBoundedContent = "_np-d";
export var internal = "_np-5";
export var merchant = "_np-8";
export var messageInputContainer = "_np-h";
export var normal = "_np-7";
export var replyCard = "_np-f";
export var subtleButton = "_np-1";
export var subtleButtonIconContainer = "_np-2";
export var toggleViewRepliesButton = "_np-c";
export var wrappingText = "_np-g";